import { ShieldCheck, UserCheck, FileLock2 } from "lucide-react";
import { IndiaIcon } from "@/components/Icons";
import { Reveal } from "@/components/Reveal";

const BADGES = [
  { icon: ShieldCheck, label: "Confidential", sub: "Your case stays private" },
  { icon: IndiaIcon, label: "PAN India", sub: "Assistance across India" },
  { icon: UserCheck, label: "Independent Advisor", sub: "We work only for you" },
  { icon: FileLock2, label: "Secure Documents", sub: "Encrypted & protected" },
];

export const TrustBadges = () => (
  <section className="py-14 sm:py-16 border-b border-zinc-200 bg-white" data-testid="trust-badges">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
        {BADGES.map((b, i) => (
          <Reveal key={b.label} delay={i * 0.08}>
            <div className="flex items-center gap-3.5" data-testid={`trust-badge-${i}`}>
              <span className="h-12 w-12 shrink-0 rounded-2xl bg-forest/10 flex items-center justify-center text-forest">
                <b.icon size={22} strokeWidth={1.75} />
              </span>
              <div className="min-w-0">
                <div className="font-bold text-ink leading-tight text-[15px] lg:text-base lg:whitespace-nowrap">{b.label}</div>
                <div className="text-xs sm:text-sm text-zinc-500 mt-0.5">{b.sub}</div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default TrustBadges;
